/**
 * adminLedgerStore — Resource-person ledger slice of the admin store.
 *
 * Endpoint:
 *   GET /api/ledger/resource-person/:id   (ADMIN; resource persons may view their own)
 */
import { API_URL } from "../../constants";
import { toDisplayString } from "../../utils/toDisplayString";
import { authHeaders, resolveToken } from "./adminUtils";

export const ledgerInitialState = {
  ledgerEntries: [],
  ledgerLoading: false,
  ledgerError: null,
  ledgerTotal: 0,
  ledgerPages: 1,
};

function normalizeListPayload(data) {
  const payload = data?.data || data || {};
  if (Array.isArray(payload)) {
    return { items: payload, total: payload.length, totalPages: 1 };
  }
  return {
    items: payload.items || payload.entries || payload.ledger || [],
    total: payload.total ?? payload.totalItems ?? 0,
    totalPages: payload.totalPages ?? payload.pages ?? 1,
  };
}

export function createLedgerActions(set, get) {
  return {
    fetchResourcePersonLedger: async (resourcePersonId, params = {}) => {
      set({ ledgerLoading: true, ledgerError: null });
      try {
        const query = new URLSearchParams(
          Object.entries(params).filter(
            ([, value]) => value !== undefined && value !== null && value !== ""
          )
        ).toString();
        const response = await fetch(
          `${API_URL}/api/ledger/resource-person/${resourcePersonId}${query ? `?${query}` : ""}`,
          { headers: authHeaders(resolveToken(get)) }
        );
        const data = await response.json();
        if (!response.ok || data.error) {
          const message = toDisplayString(data.error || data.message, "Failed to fetch ledger");
          set({ ledgerLoading: false, ledgerError: message });
          return { success: false, error: message };
        }
        const { items, total, totalPages } = normalizeListPayload(data);
        set({
          ledgerLoading: false,
          ledgerEntries: items,
          ledgerTotal: total,
          ledgerPages: totalPages,
        });
        return { success: true, entries: items, total, pages: totalPages };
      } catch (err) {
        const message = toDisplayString(err.message, "Failed to fetch ledger");
        set({ ledgerLoading: false, ledgerError: message });
        return { success: false, error: message };
      }
    },
  };
}

const ledgerActions = createLedgerActions;
export default ledgerActions;
